<template>
  <div class="app-container">
    <div class="top_tab flex_center_between">
      <div @click="branchTmp('my')" class="notActive">
        我的
      </div>
      <div class="notActive" @click="branchTmp('stu')" v-if="userInfo.roleFlag">学生</div>
      <div @click="branchTmp('tea')" v-if="userInfo.branchListTeacher.length > 0" class="notActive">教职工</div>
      <div class="active" v-if="userInfo.roleFlag">住宿生</div>
    </div>
    <van-dropdown-menu active-color="#ee0a24" :class="{'boxShadow_none': userInfo.branchListTeacher.length > 0}">
      <van-dropdown-item :title="gradeName" ref="classPicker">
        <van-picker title="请选择年级" value-key='branchName' ref="branchName" show-toolbar :default-index="gradeIndex" :columns="userInfo.branchList" @confirm="selectGrade" @cancel="cancelGrade" />
      </van-dropdown-item>
      <van-dropdown-item :title="currentDay" @open="openDate" ref="datePicker">
        <van-datetime-picker v-model="date" type="date" :max-date="maxDate" @confirm="selectDate" @cancel="cancelDate" title="请选择年月日" />
      </van-dropdown-item>
      <van-dropdown-item :title="timeName" ref="timePicker">
        <van-picker title="请选择时段" value-key='periodName' ref="periodName" show-toolbar :default-index="timeIndex" :columns="timeList" @confirm="selectTime" @cancel="cancelTime" />
      </van-dropdown-item>
    </van-dropdown-menu>
    <div class="content" :class="{'withTabHeight': userInfo.branchListTeacher.length > 0}">
      <div class="title fontBold">
        <span>年级住宿生考勤数据</span>
        <span class="fontSize14">{{ timeName && periodBeginTime &&  periodEndTime ? '（' + timeName + '：'  + periodBeginTime + '~' + periodEndTime + '）' : ''}}</span>
      </div>
      <div class="data fontSize14 marginTop5 fontBold text_c">
        <van-row>
          <van-col span="6">年级人数</van-col>
          <van-col span="6">&nbsp;已考勤</van-col>
          <van-col span="6">&nbsp;未考勤</van-col>
          <van-col span="6">体温异常</van-col>
        </van-row>
        <van-row class="marginTop5">
          <van-col span="6"> {{gradeStduentCount}}</van-col>
          <van-col span="6">&nbsp;{{attendStudentCount}}</van-col>
          <van-col span="6">&nbsp;{{noAttendStudentCount}}</van-col>
          <van-col span="6">{{exceptionStudentCount}}</van-col>
        </van-row>
      </div>
      <div class="title marginTop10 fontBold">
        <span>
          各班级详细数据
        </span>
      </div>
      <div class="table fontSize14 text_c marginTop5" ref="table">
        <van-row class="fontBold marginBottom5 paddingRight16">
          <van-col span="3">序号</van-col>
          <van-col span="6">班级</van-col>
          <van-col span="3">人数</van-col>
          <van-col span="6">已/未考勤</van-col>
          <van-col span="6">体温异常</van-col>
        </van-row>
        <div v-if="temperatureList.length === 0">
          暂无数据
        </div>
        <div v-if="temperatureList.length > 0" class="resultTable" ref="resultTable">
          <van-collapse v-model="activeCollapse" accordion>
            <van-collapse-item :name="String(index + 1)" v-for="(item,index) in temperatureList">
              <template #title>
                <van-row class="fontBold">
                  <van-col span="3">{{index + 1}}</van-col>
                  <van-col span="6">{{item.branchName}}</van-col>
                  <van-col span="3">{{item.classStudentCount}}</van-col>
                  <van-col span="6">{{item.attendStudentCount + '/' + item.noAttendStudentCount}}</van-col>
                  <van-col span="6">{{item.exceptionStudents ? item.exceptionStudents.length : 0 }}</van-col>
                </van-row>
              </template>
              <div class="fontColor00">
                <!-- <van-sticky :container="stickyContainer"> -->
                <van-row class="marginBottom5 fontBold classTitle">
                  <van-col span="6">序号</van-col>
                  <van-col span="6">学生姓名</van-col>
                  <van-col span="6">体温</van-col>
                  <van-col span="6">考勤时间</van-col>
                </van-row>
                <!-- </van-sticky> -->
                <div v-if="!item.students ||item.students.length === 0">
                  暂无数据
                </div>
                <div v-if="item.students && item.students.length > 0">
                  <van-row v-for="(_item,_index) in item.students" class="marginBottom5">
                    <van-col span="6">{{_index + 1}}</van-col>
                    <van-col span="6">{{_item.studentName}}</van-col>
                    <van-col span="6" :class="{'fontColorRed': _item.flag === 1}">{{_item.animalHeat ? _item.animalHeat : '--'}}</van-col>
                    <van-col span="6">{{_item.attendanceDate ? _item.attendanceDate : '--'}}</van-col>
                  </van-row>
                </div>
              </div>
            </van-collapse-item>
          </van-collapse>
        </div>
      </div>
      <loading :loading="isLoading"></loading>
      <floatBtn @onFloatBtnClicked="abnormalTmp" :isImg="true" :img="abnormalImg"></floatBtn>

    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { parseTime } from '@/utils/index'
import { getGradeBoarderStatCard, getGradeBoarderShiftPeriodList } from '@/api'
import loading from '@/components/loading'
import floatBtn from '@/components/floatBtn'
export default {
  computed: {
    ...mapGetters(['userInfo'])
  },
  components: { loading, floatBtn },
  data () {
    return {
      gradeId: '',
      gradeName: '',
      currentDay: '',
      date: new Date(),
      maxDate: new Date(),
      timeId: '',
      timeName: '',
      timeList: [],
      gradeIndex: 0,
      timeIndex: 0,
      temperatureList: [], // 测温表格
      periodBeginTime: '',
      periodEndTime: '',
      gradeStduentCount: 0,
      noAttendStudentCount: 0,
      attendStudentCount: 0,
      exceptionStudentCount: 0,
      activeCollapse: '1',
      isLoading: true,
      abnormalImg: '',
      stickyContainer: null
    }
  },
  created () {
    // 默认展示第一个年级的id
    this.gradeId = this.userInfo.branchList[0].branchId
    this.gradeIndex = 0
    this.gradeName = this.userInfo.branchList[0].branchName
    // 默认当天日期
    this.currentDay = parseTime(this.date, '{y}-{m}-{d}')
    this.getGradeBoarderShiftPeriodList()
  },
  // mounted() {
  //   this.$nextTick(() => {

  //   })
  // },
  methods: {
    // 获取年级所在时段
    getGradeBoarderShiftPeriodList () {
      getGradeBoarderShiftPeriodList({
        gradeId: this.gradeId,
        date: this.currentDay
      })
        .then(res => {
          if (res.code === 200) {
            this.timeList = []
            if (res && res.data.length > 0) {
              this.timeList = res.data
              // 默认展示第一个时段的数据
              this.timeIndex = 0
              this.timeName = this.timeList[0].periodName
              this.getGradeBoarderStatCard()
            } else {
              this.handleEmpty()
            }
          } else {
            this.timeList = []
            this.timeName = ''
            this.periodBeginTime = ''
            this.periodEndTime = ''
            this.handleEmpty()
          }
        })
        .catch(err => {
          this.timeList = []
          this.timeName = ''
          this.periodBeginTime = ''
          this.periodEndTime = ''
          this.handleEmpty()
          this.isLoading = false
        })
    },
    // 无数据处理
    handleEmpty () {
      this.abnormalImg = require('../../assets/img/normal.png')
      this.temperatureList = []
      this.gradeStduentCount = 0
      this.attendStudentCount = 0
      this.noAttendStudentCount = 0
      this.exceptionStudentCount = 0
      this.isLoading = false
    },
    // 选择年级
    selectGrade (value, index) {
      this.gradeIndex = index
      this.gradeName = value.branchName
      this.gradeId = value.branchId
      this.$refs.classPicker.toggle()
      // this.getGradeBoarderStatCard()
      this.getGradeBoarderShiftPeriodList()
    },
    // 取消选择年级
    cancelGrade () {
      this.$refs.branchName.setIndexes([this.gradeIndex])
      this.$refs.classPicker.toggle()
    },
    openDate () {
      this.date = new Date(this.currentDay)
    },
    // 选择日期
    selectDate (value) {
      this.currentDay = parseTime(value, '{y}-{m}-{d}')
      this.$refs.datePicker.toggle()
      // this.getGradeBoarderStatCard()
      this.getGradeBoarderShiftPeriodList()
    },
    cancelDate () {
      this.$refs.datePicker.toggle()
    },
    // 选择时段
    selectTime (value, index) {
      this.timeIndex = index
      this.timeName = value.periodName
      this.$refs.timePicker.toggle()
      this.getGradeBoarderStatCard()
    },
    cancelTime () {
      this.$refs.periodName.setIndexes([this.timeIndex])
      this.$refs.timePicker.toggle()
    },

    // 获取年级当日时段学生考勤数据
    getGradeBoarderStatCard () {
      this.isLoading = true
      const periodTime = this.timeList.filter(item => {
        return item.periodName === this.timeName
      })
      this.periodBeginTime = periodTime[0].periodBeginTime
      this.periodEndTime = periodTime[0].periodEndTime
      getGradeBoarderStatCard({
        gradeId: this.gradeId,
        periodBeginDate: this.currentDay + ' ' + this.periodBeginTime,
        periodEndDate: this.currentDay + ' ' + this.periodEndTime
      })
        .then(res => {
          if (res.code === 200) {
            if (res.data) {
              this.gradeStduentCount = res.data.gradeStduentCount
              this.attendStudentCount = res.data.gradeAttendStduentCount
              this.noAttendStudentCount = res.data.gradeNoAttendStduentCount
              this.exceptionStudentCount = res.data.gradeException.length
              if (this.exceptionStudentCount === 0) {
                this.abnormalImg = require('../../assets/img/normal.png')
              } else {
                this.abnormalImg = require('../../assets/img/abnormal.png')
              }
              this.temperatureList = res.data.listClass
            }
            this.isLoading = false
          } else {
            this.handleEmpty()
          }
        })
        .catch(err => {
          this.handleEmpty()
        })
    },
    // 异常体温
    abnormalTmp () {
      this.$router.push({
        path: '/abnormalTemperature',
        query: {
          type: 'dorm'
        }
      })
    },
    // 部门体温
    branchTmp (type) {
      if (type === 'my') {
        this.$router.push('/my')
      } else if (type === 'stu') {
        if (this.userInfo.roleFlag === 'CLASS') {
          // 班级
          this.$router.push('/classTemperature')
        } else if (this.userInfo.roleFlag === 'GRADE') {
          // 年级
          this.$router.push('/gradeTemperature')
        }
      } else {
        this.$router.push('/teacherTemperature')
      }
    }
  }
}
</script>

<style lang="less" scoped>
.app-container {
  background-color: #eff5fd;
  ::v-deep .van-popup--top {
    bottom: 0;
    top: unset;
  }
  ::v-deep .van-picker__confirm {
    color: #ee0a24;
  }
  .withTabHeight {
    height: calc(100% - 72px) !important;
  }
  .content {
    padding: 10px;
    height: calc(100% - 50px);
    .title {
      height: 30px;
      line-height: 30px;
      span:nth-child(1) {
        color: rgb(5, 182, 252);
      }
    }
    .data,
    .table {
      line-height: 20px;
      background: #cce3ff;
      border-radius: 5px;
    }
    .data {
      padding: 10px;
    }
    .table {
      padding: 10px 5px;
      max-height: calc(100% - 140px);
      display: flex;
      flex-flow: column;
      overflow: hidden;
      .resultTable {
        flex: 1;
        overflow-y: auto;
        border-radius: 5px;
      }
      .paddingRight16 {
        padding-right: 16px;
      }
      ::v-deep .van-collapse-item {
        .van-cell {
          padding: 10px 0;
          // background: #dfebfb;
        }
        .van-cell--clickable {
          cursor: pointer;
          position: sticky;
          top: -1px;
          z-index: 9;
          // top: 64px;
          // z-index: 99;
        }

        .van-collapse-item__content {
          // background: #dfebfb;
          padding: 10px 0;
          // position: relative;
        }
      }
      // font-size: 12px;
    }
  }
}
</style>